import React from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import PendingIcon from '@mui/icons-material/Pending';
import { Tooltip, useTheme } from '@mui/material';

// TODO: Replace this once svc-vcc contract exports the states types.
export enum VirtualCreditCardState {
  PENDING = 'pending',
  RESERVED = 'reserved',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
}

type Props = {
  state?: (typeof VirtualCreditCardState)[keyof typeof VirtualCreditCardState];
};

export function VirtualCreditCardStateComponent({ state }: Props) {
  const theme = useTheme();

  if (state === VirtualCreditCardState.PENDING) {
    return (
      <Tooltip title="Pending">
        <PendingIcon sx={{ color: theme.palette.warning.main }} />
      </Tooltip>
    );
  }

  if (state === VirtualCreditCardState.RESERVED) {
    return (
      <Tooltip title="Reserved: Desired balance will be available on confirmation.">
        <LockIcon sx={{ color: theme.palette.info.main }} />
      </Tooltip>
    );
  }

  if (state === VirtualCreditCardState.CONFIRMED) {
    return (
      <Tooltip title="Confirmed. Card is ready to be used.">
        <CheckCircleIcon sx={{ color: theme.palette.success.main }} />
      </Tooltip>
    );
  }

  if (state === VirtualCreditCardState.CANCELLED) {
    return (
      <Tooltip title="Cancelled. Card is no longer available.">
        <CancelIcon sx={{ color: theme.palette.error.main }} />
      </Tooltip>
    );
  }

  return null;
}
